import React, { FC } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { VerboseErrorMessageWithRCID } from '../../../../components/VerboseErrorMessageWithRCID';
import { Content } from '../../../../components/shared/Content';
import useTranslation from '../../../../hooks/useTranslation';

import './ErrorView.scss';

type Props = { error: RequestExceptionWithResponse; refresh: () => void };

export const ErrorView: FC<Props> = ({ error, refresh }) => {
    const { accountOverview, commonErrors } = useTranslation();

    return (
        <Content>
            <h2 className="error-view__title typography-subtitle-bold">{accountOverview.headingMobile}</h2>
            <VerboseErrorMessageWithRCID
                title={commonErrors.gettingAccountsFailed}
                description={commonErrors.tryLoadingAgain}
                systemErrorDescription={commonErrors.thereIsAnErrorOnOurSide}
                error={error}
                refresh={refresh}
            />
        </Content>
    );
};
